import { filter } from 'rxjs/operators';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Alert } from 'selenium-webdriver';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent extends BaseComponent implements OnInit {
  minDate = '';
  ID_sv: any;
  Ma_sv = '';
  Ho_ten = '';
  Sdt = '';
  Khoa_hoc = '';
  ID_he = '';
  ID_khoa = '';
  ID_lop = '';
  Status = 2;
  dataStudent;
  dataLopAll = [];
  ngOnInit(): void {
    this.getToken();
    //this.getList();
    this.getCount();
    this.GetHe();
  }
  getCount() {
    this.AdminDeclarationService.Count(this.Token).subscribe((z) => {
      this.totalItem = z == null ? 0 : z;
    });
  }
  GetHe() {
    this.LoadHeKhoaService.LoadHe(this.Token).subscribe((x) => {
      this.dataHe = x;
      this.LoadHeKhoaService.LoadKhoa(this.Token).subscribe((x) => {
        this.dataKhoa = x;
        this.LoadHeKhoaService.LoadLop(this.Token).subscribe((x) => {
          this.dataLop = x;
          this.dataLopAll = x;
        });
      });
    });
  }
  getListLop() {
    if (this.ID_khoa != null && this.ID_khoa != '') {
      this.dataLop = this.dataLopAll.filter((c) => c.ID_khoa == this.ID_khoa);
    } else {
      this.dataLop = this.dataLopAll;
    }
  }
  getList() {
    this.spinner.show();
    this.arrNumberPage = [];
    this.arrNumberPage_chil = [];
    let param = {
      PageSize: this.pageSize,
      Page: this.page,
      Ma_sv: this.Ma_sv,
      Ho_ten: this.Ho_ten,
      ID_he: this.ID_he,
      ID_khoa: this.ID_khoa,
      Khoa_hoc: this.Khoa_hoc,
      ID_lop: this.ID_lop,
      Da_gui: this.Status,
    };
    if (this.ID_khoa != null && this.ID_khoa != '') {
      this.dataLop = this.dataLopAll.filter((c) => c.ID_khoa == this.ID_khoa);
    } else {
      this.dataLop = this.dataLopAll;
    }
    this.AdminDeclarationService.Load(param, this.Token).subscribe((z) => {
      if (z.Status == 10) {
        this.toastr.warning(
          'Bạn không có quyền sử dụng chức năng này, vui lòng liên hệ với quản trị viên để được hỗ trợ!'
        );
        this.router.navigate(['/admin']);
        this.spinner.hide();
      } else {
        this.dataTable = z;
        this.AdminDeclarationService.CounFilter(param, this.Token).subscribe(
          (z) => {
            this.totalItemFilter = z == null ? 0 : z;
            this.numberPage = this.createNumberPage(
              z == null ? 0 : z,
              this.pageSize
            ).numberPage;
            this.arrNumberPage_chil = this.createNumberPage(
              z == null ? 0 : z,
              this.pageSize
            ).arrNumberPage_chil;
            this.spinner.hide();
          }
        );
      }
    });
  }
  refesh() {
    this.Ma_sv = '';
    this.Ho_ten = '';
    this.Sdt = '';
    this.Khoa_hoc = '';
    this.Status = 2;
    this.getList();
  }
  handlePageSizeChange(event) {
    if (event.target.value == 'Tất cả') {
      this.pageSize = 100000;
    } else {
      this.pageSize = event.target.value;
    }
    this.getList();
  }
  changPage(event) {
    this.handlePageChange(event);
    this.spinner.show();
    let dataFilter = {
      PageSize: this.pageSize,
      Page: this.page,
    };
    if (true) {
    }
    let param = {
      PageSize: this.pageSize,
      Page: this.page,
      Ma_sv: this.Ma_sv,
      Ho_ten: this.Ho_ten,
      ID_he: this.ID_he,
      ID_khoa: this.ID_khoa,
      Khoa_hoc: this.Khoa_hoc,
      ID_lop: this.ID_lop,
      Da_gui: this.Status,
    };
    this.AdminDeclarationService.Load(param, this.Token).subscribe((z) => {
      if (z.Status == 10) {
        this.toastr.warning(
          'Bạn không có quyền sử dụng chức năng này, vui lòng liên hệ với quản trị viên để được hỗ trợ!'
        );
      } else {
        this.dataTable = z;
        this.spinner.hide();
      }
    });
  }
  open(content, sizm, type, Data) {
    if (type == 'Detail') {
      this.ID_sv = Data.ID_sv;
      this.submitted = false;
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: sizm })
        .result.then(
          (result) => {
            this.closeResult = `Closed with: ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
      this.StudentService.GetAll(Data.ID_sv, this.Token).subscribe((z) => {
        this.dataStudent = z.Data;
      });
    } else {
      var current = new Date(new Date().setHours(new Date().getHours() + 24));
      this.minDate = new Date(current).toISOString().slice(0, 10);
      this.submitted = false;
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: sizm })
        .result.then(
          (result) => {
            this.closeResult = `Closed with: ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    }
  }
  Accept() {
    if (confirm('Bạn có chắn chắn muốn Từ chối duyệt hoạt động này')) {
      var param = {
        ID_sv: this.ID_sv,
        Trang_thai: 1,
      };
      this.AdminDeclarationService.MultiUpdateStatus(
        param,
        this.Token
      ).subscribe((z) => {
        if (z.Status == 2) {
          this.toastr.success(z.Message);
        } else if (z.Status == 1) {
          this.toastr.success(z.Message);
          this.StudentService.GetAll(this.ID_sv, this.Token).subscribe((z) => {
            this.dataStudent = z.Data;
          });
          this.getList();
        } else {
          this.toastr.warning(z.Message);
        }
      });
    }
  }
  Refuse() {
    if (confirm('Bạn có chắn chắn muốn Từ chối duyệt hoạt động này')) {
      var param = {
        ID_sv: this.ID_sv,
        Trang_thai: 2,
      };
      this.AdminDeclarationService.MultiUpdateStatus(
        param,
        this.Token
      ).subscribe((z) => {
        if (z.Status == 1) {
          this.toastr.success('Từ chối duyệt thành công!');
          this.StudentService.GetAll(this.ID_sv, this.Token).subscribe((z) => {
            this.dataStudent = z.Data;
          });
          this.getList();
        } else {
          this.toastr.warning(z.Message);
        }
      });
    }
  }
  Save() {
    if (confirm('Bạn có chắn chắn muốn lưu điểm')) {
      this.AdminDeclarationService.UpdateDiem(
        this.dataStudent,
        this.Token
      ).subscribe((z) => {
        if (z.Status == 1) {
          this.toastr.success('Lưu điểm thành công!');
          this.StudentService.GetAll(this.ID_sv, this.Token).subscribe((z) => {
            this.dataStudent = z.Data;
          });
        } else {
          this.toastr.warning(z.Message);
        }
      });
    }
  }
  changeDiem(value, index) {
    this.dataStudent[index].Diem_hoi_dong = value;
  }
  ExportExcel() {
    this.spinner.show();
    let param = {
      PageSize: this.pageSize,
      Page: this.page,
      Ma_sv: this.Ma_sv,
      Ho_ten: this.Ho_ten,
      ID_he: this.ID_he,
      ID_khoa: this.ID_khoa,
      Khoa_hoc: this.Khoa_hoc,
      ID_lop: this.ID_lop,
      Da_gui: this.Status,
    };
    this.AdminDeclarationService.Export(param, this.Token).subscribe((z) => {
      if (z.Status == 1) {
        this.ExportService.exportExcelByte(
          z.FileData,
          'BaoCaoSinhHoatCongDong'
        );
        this.toastr.success('File đã được tải xuống', 'Thao tác thành công');
        this.getList();
      } else {
        this.toastr.error(z.Message, 'Thao tác thất bại');
      }
    });
  }
  ExportExcelChiTiet() {
    this.spinner.show();
    let param = {
      PageSize: this.pageSize,
      Page: this.page,
      Ma_sv: this.Ma_sv,
      Ho_ten: this.Ho_ten,
      ID_he: this.ID_he,
      ID_khoa: this.ID_khoa,
      Khoa_hoc: this.Khoa_hoc,
      ID_lop: this.ID_lop,
    };
    this.AdminDeclarationService.ExportChiTiet(param, this.Token).subscribe(
      (z) => {
        if (z.Status == 1) {
          this.ExportService.exportExcelByte(
            z.FileData,
            'BaoCaoSinhHoatCongDongChiTiet'
          );
          this.toastr.success('File đã được tải xuống', 'Thao tác thành công');
          this.getList();
        } else {
          this.toastr.error(z.Message, 'Thao tác thất bại');
        }
      }
    );
  }
  chonall() {
    if ($('#checkboxall').prop('checked')) {
      for (let index = 0; index < this.dataTable.length; index++) {
        this.dataTable[index].Selected = true;
      }
    } else {
      for (let index = 0; index < this.dataTable.length; index++) {
        this.dataTable[index].Selected = false;
      }
    }
    // var table = $('#maindata').DataTable().rows({ filter: 'applied' }).data();
    // var length = table.rows({ filter: 'applied' }).nodes().length;
    // var lstID = [];
    // for (var i = 0; i < length; i++) {
    //   var ID_sinh_hoat_cong_dong = parseInt(table[i][1]);
    //   lstID.push(ID_sinh_hoat_cong_dong);
    // }
    // for (let index = 0; index < this.dataStudent.length; index++) {
    //   if (lstID.includes(this.dataStudent[index].ID_sinh_hoat_cong_dong)) {
    //     this.dataStudent[index].Selected = $('#SelectALL').prop('checked');
    //   }
    // }
  }
  SelectRow(ID_sv) {
    for (let index = 0; index < this.dataTable.length; index++) {
      if (this.dataTable[index].ID_sv == ID_sv) {
        if ($('#checkbox' + ID_sv).prop('checked')) {
          {
            this.dataTable[index].Selected = true;
          }
        } else {
          this.dataTable[index].Selected = false;
        }
        break;
      }
    }
  }
  AcceptDetail(req) {
    req = {
      ID_sinh_hoat_cong_dong: req.ID_sinh_hoat_cong_dong,
      Trang_thai: 1,
    };
    this.AdminDeclarationService.UpdateStatus(req, this.Token).subscribe(
      (z) => {
        if (z.Status == 1) {
          this.toastr.success('Duyệt thành công!');
          this.StudentService.GetAll(this.ID_sv, this.Token).subscribe((z) => {
            this.dataStudent = z.Data;
          });
          //this.getList();
        } else {
          this.toastr.warning(z.Message);
        }
      }
    );
  }

  CancelApproval(req) {
    req = {
      ID_sinh_hoat_cong_dong: req.ID_sinh_hoat_cong_dong,
      Trang_thai: 0,
    };
    this.AdminDeclarationService.UpdateStatus(req, this.Token).subscribe(
      (z) => {
        if (z.Status == 1) {
          this.toastr.success('Hủy duyệt thành công!');
          this.StudentService.GetAll(this.ID_sv, this.Token).subscribe((z) => {
            this.dataStudent = z.Data;
          });
          //this.getList();
        } else {
          this.toastr.warning(z.Message);
        }
      }
    );
  }
  RefuseDetail(req) {
    if (req.Trang_thai == 1) {
      this.toastr.warning('Hoạt động đã duyệt không được từ chối');
      return false;
    }
    req = {
      ID_sinh_hoat_cong_dong: req.ID_sinh_hoat_cong_dong,
      Trang_thai: 2,
    };
    this.AdminDeclarationService.UpdateStatus(req, this.Token).subscribe(
      (z) => {
        if (z.Status == 1) {
          this.toastr.success('Hủy duyệt thành công!');
          this.StudentService.GetAll(this.ID_sv, this.Token).subscribe((z) => {
            this.dataStudent = z.Data;
          });
          //this.getList();
        } else {
          this.toastr.warning(z.Message);
        }
      }
    );
  }
  HuyDuyetDeXuat_ListID() {
    var dt = jQuery.grep(this.dataStudent, function (pa: any, i) {
      return pa;
    });
    let req = [];
    for (var i = 0; i < dt.length; i++) {
      req.push({
        ID_sinh_hoat_cong_dong: dt[i].ID_sinh_hoat_cong_dong,
        Trang_thai: 2,
      });
    }
    this.com.CheckLogin();
    var a = this.com.getUserinfo();
    this.AdminDeclarationService.MultiUpdateStatus(req, a.Token).subscribe(
      (z) => {
        if (z.Status == 2) {
          this.toastr.success(z.Message);
        } else if (z.Status == 1) {
          this.toastr.success(z.Message);
          this.modalService.dismissAll('');
          this.getList();
        } else {
          this.toastr.warning(z.Message);
        }
      }
    );
  }
  GetStringID(m) {
    var rs = '';
    for (var k = 0; k < m.length; k++) {
      if (k == 0) {
        rs += m[k].ID_de_xuat;
      } else {
        rs += ',' + m[k].ID_de_xuat;
      }
    }
    return rs;
  }

  Action = new FormGroup({
    Thoi_gian: new FormControl(null, [
      Validators.required,
      Validators.maxLength(500),
    ]),
  });
  onSubmit() {
    this.submitted = true;
    if (this.Action.invalid) {
      return false;
    }
    if (confirm('Bạn có chắn chắn muốn gia hạn thời gian')) {
      var time = this.Action.controls.Thoi_gian.value;
      this.modalService.dismissAll('AddModal');
      var rep = [];
      this.dataTable.forEach((element) => {
        if (element.Selected == true) {
          rep.push({ ID_sv: element.ID_sv, Den_ngay: time });
        }
      });
      this.AdminSystemService.InsertGiaHanList(rep, this.Token).subscribe(
        (z) => {
          if (z.Status == 1) {
            $('#checkboxall').prop('checked', false);
            this.toastr.success('Gia hạn thành công!');
            this.getList();
          } else {
            this.toastr.warning(z.Message);
          }
        }
      );
    }
  }
  get checkvalue() {
    return this.Action.controls;
  }
}
